import { Autocomplete, Box, Checkbox, Chip, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { colorBrandObject } from "../../../../constants/brandings";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BoxPayAutoComplete = (props) => {
  const [selectedValues, setSelectedValues] = useState(
    props.currenciesSelected
  );

  useEffect(() => {
    const creds = sessionStorage.getItem("storeCreds");
    const getCreds = JSON.parse(creds);
    if (sessionStorage.getItem("storeCreds")) {
      for (let i = 0; i < getCreds.length; i++) {
        if (getCreds[i].pspCode === props.value) {
          setSelectedValues(getCreds[i].chooseCurrencies);
        }
      }
    }
  }, []);

  const onDelete = (name) => () => {
    setSelectedValues((selectedValues) =>
      selectedValues.filter((v) => v.name !== name)
    );
  };

  useEffect(() => {
    props.setCurrenciesSelected(selectedValues);
  }, [selectedValues]);

  return (
    <div>
      <Autocomplete
        multiple
        options={props.options}
        disableCloseOnSelect
        getOptionLabel={(option) => option.name}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
              sx={{
                '& .MuiSvgIcon-root': {
                  color: colorBrandObject?.secondaryButtonColor,
                },
                '&.Mui-checked': {
                  color: colorBrandObject?.secondaryButtonColor,
                  '& .MuiSvgIcon-root': {
                    fill: colorBrandObject?.secondaryButtonColor,
                  },
                },
              }}
            />
            {option.name}
          </li>
        )}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        value={selectedValues}
        onChange={(e, newValue) => setSelectedValues(newValue)}
        renderTags={() => null}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder="Select" />
        )}
        ListboxProps={{
          style: {
            maxHeight: '180px',
            overflowY: 'auto',
          },
        }}
      />
      <Box
        mt={2}
        sx={{
          "& > :not(:last-child)": { marginRight: 1 },
          "& > *": { marginBottom: 1 },
          marginTop: "5px",
        }}
      >
        {selectedValues.map((v) => (
          <Chip
            sx={{ marginBottom: 1 }}
            key={v.id}
            label={v.name}
            onDelete={onDelete(v.name)}
          />
        ))}
      </Box>
    </div>
  );
};

export default BoxPayAutoComplete;
